// extracted by mini-css-extract-plugin
module.exports = {"page":"classPage_page__2ye9V","details":"classPage_details__234TE","scheduleTable":"classPage_scheduleTable__1HOg-"};